<template>
    <div class="dangdang-pc-home">
        <HeaderPc />

        <!-- 分类和轮播 -->
        <div class="main-banner-wrapper">
            <div class="container">
                <div class="dark-category-nav">
                    <div class="category-list">
                        <div 
                            class="category-item"
                            v-for="item in categoryList"
                            :key="item.id"
                            :class="{ 'category-item-active': activeCategoryId === item.id }"
                            @mouseenter="onItemHover(item.id)"
                            @mouseleave="onItemLeave"   
                            @click="handleGoCategory(item.id)"
                        >
                            <span class="category-name">{{ item.name }}</span>
                            <i class="el-icon-arrow-right category-arrow"></i>
                        </div>
                    </div>
                </div>

                <div 
                    class="category-submenu" 
                    v-if="activeId && isShowSub && activeSubList.length > 0"
                    @mouseenter="onSubHover"
                    @mouseleave="onSubLeave"
                >
                    <div class="submenu-header">
                        <span class="submenu-title">{{ activeCategory?.name }}</span>
                        <span class="submenu-count">{{ activeSubList.length }}个子分类</span>
                    </div>
                    <div class="submenu-content">
                        <div
                            v-for="sub in activeSubList"
                            :key="sub.id"
                            class="submenu-item"
                            @click="handleGoSubCategory(sub.id)"
                        >
                            <i class="el-icon-right"></i>
                            <span>{{ sub.name }}</span>
                        </div>
                    </div>
                </div>
                <div class="banner-area">
                    <el-carousel 
                        height="420px" 
                        indicator-position="bottom" 
                        class="business-banner"
                        :autoplay="true"
                        :autoplay-interval="4000"
                        @change="handleBannerChange"
                        arrow="always"
                    >
                        <el-carousel-item v-for="item in bannerList" :key="item.id">
                            <img 
                                :src="getImageUrl(item.img)" 
                                alt="课程banner" 
                                class="banner-img" 
                                @click="handleBannerClick(item)"
                                @error="handleImgError($event)" 
                            />
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>
        </div>

        <div class="recommend-container">
            <div class="recommend-block newest-block">
                <div class="block-header">
                    <i class="el-icon-date"></i>
                    <span class="block-title">最新推荐</span>
                    <span class="block-desc">最新上线的优质课程</span>
                </div>
                <div class="course-list">
                    <div 
                        class="course-card" 
                        v-for="item in newestCourses" 
                        :key="item.id"
                        @click="goCourseDetail(item.id)"
                    >
                        <div class="course-cover">
                            <img :src="getImageUrl(item.cover)" :alt="item.name" @error="handleImgError($event)">
                            <span class="video-tag">{{ item.ctype == 1 ? '视频' : '课件' }}</span>
                        </div>
                        <div class="course-info">
                            <h4 class="course-title" :title="item.name">{{ item.name }}</h4>
                            <div class="course-meta">
                                <span class="teacher"><i class="el-icon-user"></i> {{ item.author_name }}</span>
                                <span class="update-time"><i class="el-icon-calendar"></i> {{ item.update_time }}</span>
                            </div>
                            <div class="course-stats">
                                <span><i class="el-icon-user"></i> {{ item.student_count || 0 }}人收藏</span>
                            </div>
                        </div>  
                    </div>
                </div>
            </div>
            <div class="recommend-block hottest-block">
                <div class="block-header">
                    <i class="el-icon-s-opportunity"></i>
                    <span class="block-title">最热推荐</span>
                    <span class="block-desc">最受欢迎的热门课程</span>
                </div>
                <div class="course-list">
                    <div 
                        class="course-card" 
                        v-for="course in hottestCourses" 
                        :key="course.id"
                        @click="goCourseDetail(course.id)"
                    >
                        <div class="course-cover">
                            <img :src="getImageUrl(course.cover)" :alt="course.name" @error="handleImgError($event)">
                            <span class="video-tag">{{ course.ctype == 1 ? '视频' : '课件' }}</span>
                        </div>
                        <div class="course-info">
                            <h4 class="course-title" :title="course.name">{{ course.name || '' }}</h4>
                            <div class="course-meta">
                                <span class="teacher"><i class="el-icon-user"></i> {{ course.author_name || '' }}</span>
                            </div>
                            <div class="course-stats">
                                <span><i class="el-icon-video-play"></i> {{ course.looks || 0 }}次播放</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="recommend-block popular-block" v-if="false">
                <div class="block-header">
                    <i class="el-icon-star-on"></i>
                    <span class="block-title">最受欢迎</span>
                    <span class="block-desc">最受欢迎的精品课程</span>
                </div>
                <div class="course-list">
                    <div 
                        class="course-card" 
                        v-for="course in popularCourses" 
                        :key="course.id"
                        @click="goCourseDetail(course.id)"
                    >
                        <div class="course-cover">
                            <img :src="getImageUrl(course.cover)" :alt="course.name" @error="handleImgError($event)">
                            <span class="video-tag">精品</span>
                        </div>
                        <div class="course-info">
                            <h4 class="course-title" :title="course.title">{{ course.name || '' }}</h4>
                            <div class="course-meta">
                                <span class="teacher"><i class="el-icon-user"></i> {{ course.author_name || '' }}</span>
                                <span class="collect"><i class="el-icon-star-off"></i> {{ course.student_count || 0 }}收藏</span>
                            </div>
                            <div class="course-stats">
                                <span><i class="el-icon-view"></i> {{ course.looks || 0 }}次浏览</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="recommend-block author-block" v-if="false">
                <div class="block-header">
                    <i class="el-icon-user-solid"></i>
                    <span class="block-title">热门作者</span>
                    <span class="block-desc">最受欢迎的优质作者</span>
                </div>
                <div class="author-list">
                    <div 
                        class="author-card" 
                        v-for="author in popularAuthors" 
                        :key="author.id"
                        @click="goAuthorDetail(author)"
                    >
                        <div class="author-avatar">
                            <img :src="getImageUrl(author.avatar)" :alt="author.name" @error="handleImgError($event)">
                        </div>
                        <div class="author-info">
                            <h4 class="author-name">{{ author.name || '' }}</h4>
                            <p class="author-desc">{{ author.description || '' }}</p>
                            <div class="author-stats">
                                <span><i class="el-icon-document"></i> 发布课程: {{ author.course_count || 0 }}</span>
                            </div>
                            <div class="author-stats">
                                <span><i class="el-icon-user"></i>粉丝: {{ author.fans_count || 0 }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <FooterPc />
    </div>
</template>

<script>
import HeaderPc from '@/components/pc/header.vue';
import FooterPc from '@/components/pc/fotter.vue';
import { getCategory, getCarousel, getHome } from '@/api/home';

export default {
    name: 'PcIndex',
    components: {
        HeaderPc,
        FooterPc
    },
    data() {
        return {
            categoryList: [],
            bannerList: [],
            activeId: null,
            isShowSub: false,
            timer: null,
            hoverCategoryId: null,
            isSubmenuHover: false,
            newestCourses: [],
            hottestCourses: [],
            popularCourses: [],
            popularAuthors: []
        };
    },
    computed: {
        activeSubList() {
            const activeItem = this.categoryList.find(item => item.id === this.activeId);
            return activeItem ? (activeItem.children || []) : [];
        },
        activeCategory() {
            return this.categoryList.find(item => item.id === this.activeId);
        }
    },
    created() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            Promise.all([
                getCategory(),
                getCarousel(),
                getHome()
            ]).then(([categoryRes, carouselRes, homeRes]) => {
                this.categoryList = categoryRes.data || [];
                this.bannerList = carouselRes.data || [];
                this.newestCourses = (homeRes.data?.newest || []).slice(0, 12);
                this.hottestCourses = (homeRes.data?.hot_view || []).slice(0, 12);
                this.popularCourses = (homeRes.data?.hot_collect || []).slice(0, 12);
                this.popularAuthors = (homeRes.data?.hot_author || []).slice(0, 12);
            }).catch(error => {
                console.error('获取首页数据失败:', error);
            });
        },
        onItemHover(id) {
            clearTimeout(this.timer);
            this.activeId = id;
            this.isShowSub = true;
        },
        onItemLeave() {
            this.timer = setTimeout(() => {
                this.isShowSub = false;
                this.activeId = null;
            }, 300);
        },
        onSubHover() {
            clearTimeout(this.timer);
            this.isShowSub = true;
        },
        onSubLeave() {
            this.isShowSub = false;
            this.activeId = null;
        },
        handleGoCategory(id) {
            this.$router.push(`/category/${id}`);
        },
        handleGoSubCategory(id) {
            this.$router.push(`/category/${id}`);
        },
        handleBannerChange(index) {
            // console.log("轮播切换到第", index + 1, "张");
        },
        handleBannerClick(banner) {
            if (!banner.type || banner.type === 0) return;
            
            if (banner.type === 1) {
                this.$router.push(`/category/${banner.cid}`);
            } else if (banner.type === 2) {
                this.$router.push(`/course/${banner.course_id}`);
            } else if (banner.type === 3) {
                window.open(banner.url, '_blank');
            }
        },
        getImageUrl(url) {
            if (!url) return require('@/static/imgs/default.jpeg');
            if (typeof url === 'string' && (url.startsWith('http://') || url.startsWith('https://'))) return url;
            return process.env.VUE_APP_STATIC_URL + url;
        },
        hoverCategory(id) {
            this.onItemHover(id);
        },
        leaveCategory() {
            this.onItemLeave();
        },
        keepSubmenuShow() {
            this.onSubHover();
        },
        goCourseDetail(id){
            this.$router.push(`/course/${id}`);
        },
        goAuthorDetail(author){
            this.$router.push('/search?keyword=' + author.name + '&type=teacher');
        },
        handleImgError(event) {
            event.target.src = require('@/static/imgs/default.jpeg');
        }
    },
    beforeDestroy() {
        clearTimeout(this.timer);
    }
};
</script>

<style scoped>
    .dangdang-pc-home {
        width: 100%;
        min-height: 100vh;
        background: #f5f5f5;
    }
    .main-banner-wrapper {
        width: 100%;
        background: transparent;
        margin: 10px 0;
    }
    .container {
        width: 80%;
        margin: 0 auto;
        display: flex;
        position: relative;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 2px 12px rgba(0,0,0,0.08);
    }

    .dark-category-nav {
        width: 200px;
        height: 420px;
        background: #fff;
        color: #333;
        overflow-y: auto;
        scrollbar-width: none;
        border-radius: 0;
        border-right: 1px solid #f0f0f0;
    }
    .dark-category-nav::-webkit-scrollbar {
        display: none;
    }
    .category-list {
        width: 100%;
        height: 100%;
    }
    .category-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 46.7px;
        line-height: 48px;
        padding: 0 20px;
        cursor: pointer;
        transition: all 0.3s ease;
        border-bottom: 1px solid #f5f5f5;
        position: relative;
    }
    .category-item::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 0;
        height: 60%;
        background: #2d8cf0;
        transition: width 0.3s ease;
        border-radius: 0 4px 4px 0;
    }
    .category-item:hover {
        background: #f0f7ff;
        padding-left: 24px;
    }
    .category-item:hover::before {
        width: 4px;
    }
    .category-name {
        font-size: 14px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-weight: 400;
        color: #333;
        transition: all 0.3s ease;
    }
    .category-item:hover .category-name {
        color: #2d8cf0;
        font-weight: 500;
    }
    .category-arrow {
        font-size: 12px;
        color: #999;
        transition: all 0.3s ease;
    }
    .category-item:hover .category-arrow {
        color: #2d8cf0;
        transform: translateX(3px);
    }

    .category-submenu {
        position: absolute;
        left: 200px;
        top: 0;
        width: 250px;
        height: 420px;
        background: #fff;
        border-radius: 0;
        box-shadow: 0 4px 16px rgba(0,0,0,0.1);
        padding: 0;
        z-index: 9999;
        overflow: hidden;
        animation: slideIn 0.2s ease-out;
    }
    @keyframes slideIn {
        from {
            opacity: 0;
            transform: translateX(-10px);
        }
        to {
            opacity: 1;
            transform: translateX(0);
        }
    }
    .submenu-header {
        padding: 10px 20px;
        background: #f8f9fa;
        border-bottom: 2px solid #2d8cf0;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .submenu-title {
        font-size: 15px;
        font-weight: 600;
        color: #333;
    }
    .submenu-count {
        font-size: 12px;
        color: #2d8cf0;
        background: #e6f2ff;
        padding: 3px 10px;
        border-radius: 10px;
    }
    .submenu-content {
        padding: 12px;
        height: calc(420px - 56px);
        overflow-y: auto;
    }
    .submenu-content::-webkit-scrollbar {
        width: 6px;
    }
    .submenu-content::-webkit-scrollbar-thumb {
        background: #d0d0d0;
        border-radius: 3px;
    }
    .submenu-content::-webkit-scrollbar-thumb:hover {
        background: #b0b0b0;
    }
    .submenu-item {
        display: flex;
        align-items: center;
        padding: 10px 14px;
        color: #333;
        font-size: 14px;
        margin-bottom: 4px;
        border-radius: 6px;
        cursor: pointer;
        transition: all 0.2s ease;
        background: #fff;
    }
    .submenu-item i {
        font-size: 12px;
        margin-right: 8px;
        color: #2d8cf0;
        transition: transform 0.2s ease;
    }
    .submenu-item:hover {
        background: #f0f7ff;
        color: #2d8cf0;
        transform: translateX(3px);
    }
    .submenu-item:hover i {
        transform: translateX(2px);
    }
    .category-item-active {
        background: #e6f2ff !important;
        padding-left: 24px !important;
    }
    .category-item-active::before {
        width: 4px !important;
    }
    .category-item-active .category-name {
        color: #2d8cf0;
        font-weight: 600;
    }
    .category-item-active .category-arrow {
        color: #2d8cf0;
    }

    .banner-area {
        flex: 1;
        height: 420px;
        overflow: hidden;
    }
    .business-banner {
        width: 100%;
        height: 100%;
    }
    .banner-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        cursor: pointer;
    }
    .recommend-container {
        width: 80%;
        margin: 0 auto 40px;
        display: flex;
        flex-direction: column;
        gap: 30px;
        padding: 20px 0;
    }
    .recommend-block {
        width: 100%;
        padding: 20px 24px;
        background: #fff;
        border-radius: 12px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
        box-sizing: border-box;
    }
    .block-header {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        padding-bottom: 15px;
        border-bottom: 1px solid #f5f7fa;
    }
    .block-header i { font-size: 20px; margin-right: 10px; }
    .newest-block .block-header i, .newest-block .block-title { color: #1890ff; }
    .hottest-block .block-header i, .hottest-block .block-title { color: #f56c6c; }
    .popular-block .block-header i, .popular-block .block-title { color: #faad14; }
    .author-block .block-header i, .author-block .block-title { color: #52c41a; }
    .block-title {
        font-size: 18px;
        font-weight: 600;
        margin-right: 10px;
    }
    .block-desc { font-size: 12px; color: #94a3b8; }

    /* 多列卡片布局 */
    .course-list {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 16px;
    }
    .course-card {
        background: #fff;
        border-radius: 10px;
        overflow: hidden;
        border: 1px solid #f0f0f0;
        cursor: pointer;
        transition: all 0.3s ease;
        display: flex;
        flex-direction: column;
    }
    .course-card:hover {
        transform: translateY(-4px);
        box-shadow: 0 12px 28px rgba(0, 0, 0, 0.12);
        border-color: #d0e8ff;
    }
    .course-cover {
        position: relative;
        width: 100%;
        height: 140px;
        overflow: hidden;
        flex-shrink: 0;
    }
    .course-cover img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.4s ease;
    }
    .course-card:hover .course-cover img { transform: scale(1.06); }
    .video-tag {
        position: absolute;
        top: 8px;
        left: 8px;
        padding: 2px 8px;
        background: rgba(24, 144, 255, 0.88);
        color: #fff;
        font-size: 11px;
        border-radius: 4px;
        backdrop-filter: blur(4px);
    }
    .course-info {
        padding: 12px 14px 14px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        flex: 1;
    }
    .course-title {
        font-size: 13px;
        font-weight: 600;
        color: #1f2937;
        margin: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 1.5;
    }
    .course-meta {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 11px;
        color: #888;
    }
    .course-meta span {
        display: flex;
        align-items: center;
        gap: 3px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .course-meta i { font-size: 11px; }
    .course-stats {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 8px;
        border-top: 1px solid #f5f5f5;
        font-size: 11px;
        color: #aaa;
    }
    .course-stats i { font-size: 11px; margin-right: 3px; }

    /* 作者列表样式 */
    .author-list {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 16px;
    }
    .author-card {
        background: #fff;
        border-radius: 8px;
        padding: 20px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        cursor: pointer;
        transition: all 0.3s ease;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
    }
    .author-card:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 24px rgba(82, 196, 26, 0.15);
    }
    .author-avatar {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        overflow: hidden;
        margin-bottom: 12px;
    }
    .author-avatar img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .author-info {
        width: 100%;
    }
    .author-name {
        font-size: 16px;
        font-weight: 600;
        color: #1f2937;
        margin: 0 0 8px 0;
    }
    .author-desc {
        font-size: 12px;
        color: #666;
        margin: 0 0 12px 0;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        min-height: 18px;
    }
    .author-stats {
        display: flex;
        justify-content: flex-start;
        gap: 16px;
        font-size: 12px;
        color: #94a3b8;
    }
    .author-stats span {
        display: flex;
        align-items: center;
    }
    .author-stats i {
        font-size: 10px;
        margin-right: 4px;
    }

    /* 响应式适配 */
    @media (max-width: 1280px) {
        .course-list { grid-template-columns: repeat(3, 1fr); }
        .author-list { grid-template-columns: repeat(3, 1fr); }
    }
    @media (max-width: 960px) {
        .course-list { grid-template-columns: repeat(2, 1fr); }
        .author-list { grid-template-columns: repeat(2, 1fr); }
    }
    @media (max-width: 576px) {
        .course-list { grid-template-columns: 1fr; }
        .author-list { grid-template-columns: 1fr; }
    }
</style>